module.exports = __webpack_public_path__ + "7e4fa5c6d7cbb624036441da7800cf6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/annemarie_berlinger.png
// module id = 124
// module chunks = 0